import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,53 L1386.67,53 L1386.67,395.083 C1335.8,380.698 1282.13,373 1226.67,373 C902.66,373 640,635.66 640,959.667 C640,1283.67 902.66,1546.33 1226.67,1546.33 C1282.13,1546.33 1335.8,1538.64 1386.67,1524.25 L1386.67,1866.33 L0,1866.33 L0,53 Z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1226.67,1439.67 C1340,1439.67 1444.15,1400.39 1526.27,1334.71 L1828.64,1637.36 C1849.46,1658.2 1883.23,1658.21 1904.06,1637.4 C1924.9,1616.58 1924.92,1582.81 1904.1,1561.97 L1601.69,1259.29 C1667.39,1177.17 1706.67,1073 1706.67,959.667 C1706.67,694.57 1491.76,479.667 1226.67,479.667 C961.57,479.667 746.667,694.57 746.667,959.667 C746.667,1224.76 961.57,1439.67 1226.67,1439.67 Z M1226.67,1333 C1432.85,1333 1600,1165.85 1600,959.667 C1600,753.48 1432.85,586.333 1226.67,586.333 C1020.48,586.333 853.333,753.48 853.333,959.667 C853.333,1165.85 1020.48,1333 1226.67,1333 Z"
}));

var IconReviewScreenSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconReviewScreenSolid, _Component);

  var _super = _createSuper(IconReviewScreenSolid);

  function IconReviewScreenSolid() {
    _classCallCheck(this, IconReviewScreenSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconReviewScreenSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconReviewScreen",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconReviewScreenSolid.displayName = "IconReviewScreenSolid";
  return IconReviewScreenSolid;
}(Component);

IconReviewScreenSolid.glyphName = 'review-screen';
IconReviewScreenSolid.variant = 'Solid';
IconReviewScreenSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconReviewScreenSolid;
export { IconReviewScreenSolid };